import { Box, Typography } from '@mui/material';

export function DailyQuotaProvidersNoData() {
  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#fff3e8',
          px: 2,
          py: 1,
        }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}>
          <Box
            sx={{
              width: '2px',
              height: '30px',
              backgroundColor: '#ff8210',
            }}
          />
          <Box
            width="100%"
            display="flex"
            flexWrap="wrap"
            flexDirection={{ xs: 'column', md: 'row' }}
            textTransform="uppercase"
            alignItems={{ xs: 'flex-start', md: 'center' }}>
            <Typography component="span">
              Os valores diários ainda não foram providos pelo administrador.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
